<template>
	<div>
		<!-- 我的优惠券 -->
		<div class>
			<van-row class="coupon-list">
				<van-col v-for="(item, index) in data" :key="index" :span="12" class="i-col">
					<van-row class="pr10 mb20 bgfff" type="flex" align="center">
						<van-col
							class="quan flex align-items-center justify-content-center"
							style="flex: 0 0 25%;"
							:class="{ gray: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }"
						>
							<h4
								class="mt0 mb08 f40 lh45 pr10 font"
								:class="item.DeductionMode != 2 ? (item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) ? 'price-icon-gray' : 'price-icon') : ''"
							>
								<span
									v-if="item.DeductionMode != 2"
									:class="item.DeductionMode == 1 && item.DeductionLimit && item.DeductionLimit.toString().length > 3 ? 'f30' : 'f40'"
								>
									{{ item.DeductionMode == 1 ? item.DeductionLimit : '全' }}
								</span>
								<span v-if="item.DeductionMode == 2 && item.LimitF">{{ item.LimitF }}</span>
								<span v-if="item.DeductionMode == 2 && item.LimitL" class="f12 lhn">{{ item.LimitL }}</span>
								<span class="f12 lhn" v-if="item.DeductionMode == 2">折</span>
							</h4>
							<h4 v-if="item.UseRequire && item.UseRequire.GoodsLimitPrice" class="f12 fw600 mt0 mb5">满{{ item.UseRequire.GoodsLimitPrice }}元可用</h4>
							<h4 v-if="item.UseRequire && item.UseRequire.GoodsLimitNumber" class="f12 fw600 mt0 mb0">满{{ item.UseRequire.GoodsLimitNumber }}元可用</h4>
						</van-col>
						<van-col
							:span="24"
							style="flex: 0 0 72%;"
							class="text-left quan-right-box"
							:class="{
								'gray-right-box':
									((item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue)) && page != 'VoucherCenter') ||
									(!item.IsDestroy && !item.IsOverdue && item.IsReceive && page == 'VoucherCenter')
							}"
						>
							<div class="pl10 mb28 flex align-items-center">
								<van-tag class="mr5 f12" :color="item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) ? '#c2c2c2' : '#4191F8'">
									{{ item.Goods && item.Goods.length ? '商品券' : '现金券' }}
								</van-tag>
								<span
									class="c222 f14"
									:class="{ c999: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }"
									v-if="!item.Goods || !item.Goods.length"
								>
									全场通用
								</span>
								<span
									class="c222 f14"
									:class="{ c999: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }"
									v-else-if="item.Goods && item.Goods.length > 1"
								>
									仅限部分商品可用
								</span>
								<span class="c222 ellipsis-row2 f14" :class="{ c999: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }" v-else>
									仅限购买【{{ _truncature((item.Goods && item.Goods[0].GoodsName) || '无名', 18) }}】商品
								</span>
							</div>
							<van-row type="flex" align="center">
								<van-col :span="15" v-if="item.OutCouponDto">
									<div
										class="pl10 f12 c222"
										:class="{ c999: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }"
										v-if="!item.OutCouponDto.OutCouponIssueDto.FailureDays || item.OutCouponDto.IsReceive"
									>
										有效期至：{{ item.OutCouponDto.ValidityEndTime || '' }}<!-- {{ _setTimeStr(item.BeginTime || '', 'date') }} -  {{ _setTimeStr(item.EndTime || '', 'date') }} -->
									</div>
									<div class="pl10 f12 c222" v-else>{{ `领取后${item.OutCouponDto.OutCouponIssueDto.FailureDays}天内有效` }}</div>
								</van-col>
								<van-col :span="15" v-else>
									<div
										class="pl10 f12 c222"
										:class="{ c999: item.IsOverdue || (item.IsUse && !item.IsDestroy && !item.IsOverdue) }"
										v-if="!item.OutCouponIssueDto.FailureDays || item.IsReceive"
									>
										有效期至：{{ item.ValidityEndTime || '' }}<!-- {{ _setTimeStr(item.BeginTime || '', 'date') }} -  {{ _setTimeStr(item.EndTime || '', 'date') }} -->
									</div>
									<div class="pl10 f12 c222" v-else>{{ `领取后${item.OutCouponIssueDto.FailureDays}天内有效` }}</div>
								</van-col>
								<van-col :span="9" class="text-right">
									<img src="../assets/mine/yishiyong.png" alt v-if="item.IsUse && !item.IsDestroy && !item.IsOverdue" class="size72" />
									<img src="../assets/mine/yiguoqi.png" alt v-if="item.IsOverdue" class="size72" />
									<van-button class="couponGray" v-if="!item.IsReceive && !item.IsHasCoupon" disabled>已领完</van-button>
									<van-button class="couponPrimary" @click.stop="() => handleDraw(item)" v-if="item.IsHasCoupon && !item.IsReceive" :loading="item.loading">
										立即领取
									</van-button>
									<van-button
										class="couponPrimary"
										@click.stop="() => handleUse(item)"
										v-if="!item.IsUse && !item.IsDestroy && !item.IsOverdue && item.IsReceive && page != 'VoucherCenter'"
									>
										立即使用
									</van-button>
									<van-button
										class="couponPrimary-plain"
										@click.stop="() => handleUse(item)"
										v-if="!item.IsUse && !item.IsDestroy && !item.IsOverdue && item.IsReceive && page == 'VoucherCenter'"
									>
										立即使用
									</van-button>
								</van-col>
							</van-row>
						</van-col>
					</van-row>
				</van-col>
			</van-row>
		</div>
	</div>
</template>
<script>
import { BaseMixin } from '../mixins/BaseMixin.js';
export default {
	name: 'iCoupon',
	mixins: [BaseMixin],
	props: {
		data: {
			type: Array,
			default: () => []
		},
		page: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			receiveLoading: false
		};
	},
	methods: {
		fomatDate(valueTime) {
			if (valueTime) {
				var newDate = new Date();
				var diffTime = 0;
				var currentDate = undefined;
				if (typeof valueTime == 'string') {
					currentDate = new Date(valueTime.replace(/-/g, '/'));
					diffTime = newDate.getTime() - currentDate.getTime();
				}
				return diffTime >= 0 ? true : false;
			}
		},
		// 立即领取
		async handleDraw(item) {
			let params = { couponPackageId: item.Id };
			this.receiveLoading = true;
			item.loading = true;
			const res = await this.postAction('/api_coupon/Coupon/SelfReceiveCoupons?couponPackageId=' + item.Id);
			item.loading = false;
			this.receiveLoading = false;
			//console.log("获取领取券数据", res.Data);
			if (res.IsSuccess && res.Data) {
				//重新加载列表之前临时修改数据，保证按钮状态
				this.$emit('handleDraw');
				item.IsUse = false;
				item.IsDestroy = false;
				item.IsOverdue = false;
				item.IsReceive = true;
				this.$forceUpdate();
			} else {
				this.$toast.fail('领取失败\n' + res.Msg);
			}
		},
		// 立即使用
		handleUse(item) {
			if (this.page != 'ProductDetails') {
				consolelog(item.Goods)
				// this.$hys.openLoading();
				// if (item.Goods && item.Goods.length===1) {
				// 	this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Goods[0].GoodsSkuId, '_blank');
				// 	this.$hys.clearLoading();
				// } else if (item.Goods && item.Goods.length>1) {
        //   this._jump(this.Enum_LinkTypeCode.ProductList,{ids:item.Goods.map((i)=>{return i.GoodsSkuId}).join(',')},'_blank')
				// 	this.$hys.clearLoading();
				// } else {
				// 	this._jump(this.Enum_LinkTypeCode.ProductList, null, '_blank');
				// 	this.$hys.clearLoading();
				// }
			} else {
				this.$emit('handleUse', item);
			}
		}
	}
};
</script>
<style lang="less" scoped>
.coupon-list {
	/deep/.van-col.i-col:nth-child(odd) {
		padding-right: 10px;
	}

	/deep/.van-col.i-col:nth-child(even) {
		padding-left: 10px;
	}
}

.quan {
	background: url('../assets/coupon-normal.png') no-repeat;
	background-size: 116px 110px;
	width: 116px;
	min-width: 116px;
	height: 110px;
	color: #fff;
	padding: 10px;
	flex-direction: column;
}

.quan-right-box {
	background: rgba(255, 255, 255, 1);
	border: 2px solid rgba(15, 110, 234, 1);
	border-left: 0;
	height: 110px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-right: 10px;
	padding-top: 15px;
	padding-bottom: 15px;
}

.gray {
	background: url('../assets/coupon-disabled.png') no-repeat;
	background-size: 230px 205px;
}

.gray-right-box {
	border-color: #e8e8e8;
}

.voucher-bg {
	background: url('../assets/mine/lingquan-bg.png') no-repeat;
	background-size: 230px 205px;
}

.price-icon {
	position: relative;

	span {
		display: inline-block;
	}

	&::after {
		content: '';
		background: url('../assets/coupon/money.png');
		position: absolute;
		width: 22px;
		height: 22px;
		background-size: 22px 22px;
		right: -16px;
		bottom: 5px;
	}
}

.price-icon-gray {
	position: relative;

	span {
		display: inline-block;
	}

	&::after {
		content: '';
		background: url('../assets/coupon/money-gray.png');
		position: absolute;
		width: 22px;
		height: 22px;
		background-size: 22px 22px;
		right: -15px;
		bottom: 5px;
	}
}

.price-icon-yel {
	position: relative;

	span {
		display: inline-block;
	}

	&::after {
		content: '';
		background: url('../assets/mine/lingquan-money.png');
		position: absolute;
		width: 22px;
		height: 22px;
		background-size: 22px 22px;
		right: -15px;
		bottom: 5px;
	}
}

.van-tag {
	padding: 2px 4px;
	border-radius: 20px;
	line-height: 18px;
	min-width: 52px;
	justify-content: center;
}

.couponGray {
	min-width: 84px;
	padding: 2px 14px;
	height: 26px;
	background: linear-gradient(175deg, rgba(194, 194, 194, 1) 0%, rgba(225, 225, 225, 1) 100%);
	box-shadow: 0px 2px 10px 0px rgba(234, 234, 234, 1);
	border-radius: 23px;
	color: #fff;
	font-size: 14px;
	text-shadow: 0px 2px 10px rgba(234, 234, 234, 1);
}

.couponPrimary {
	min-width: 84px;
	padding: 2px 14px;
	height: 26px;
	background: linear-gradient(175deg, rgba(66, 167, 255, 1) 0%, rgba(33, 118, 228, 1) 100%);
	box-shadow: 0px 2px 10px 0px rgba(234, 234, 234, 1);
	border-radius: 23px;
	color: #fff;
	font-size: 14px;
	text-shadow: 0px 2px 10px rgba(234, 234, 234, 1);
}

.couponPrimary-plain {
	min-width: 84px;
	padding: 2px 14px;
	height: 26px;
	background: rgba(255, 255, 255, 1);
	border-radius: 23px;
	border: 1px solid rgba(15, 110, 234, 1);
	color: #0f6ee9;
	font-size: 14px;
}

.van-button--disabled {
	opacity: 1;
}

.size72 {
	width: 72px;
	height: 82px;
	position: absolute;
	top: 50%;
	right: 0;
	z-index: 1;
	transform: translateY(-50%);
}

/deep/.van-button--loading {
	.van-loading__spinner {
		width: 12px !important;
		height: 12px !important;
	}
}
/deep/ h4 {
	color: #ffffff;
}

.f80 {
	font-size: 80px;
}

.mb08 {
	margin-bottom: 8px;
}

.mb40 {
	margin-bottom: 40px;
}
</style>
